export default __webpack_public_path__ + "static/media/deliveryIcon.3c5eba78.jpg";